import { useAppDispatch } from 'client/hooks/use-dispatch'
import { SettingsEditingType } from 'client/store'
import {
  setEditingEntity,
  setSettingsEditing,
} from 'client/store/management/managementActions'
import React, { useCallback } from 'react'
import { DiagnosticFinding } from '../types'
import { SeverityBadge } from './severity-badge'

interface FindingRowProps {
  finding: DiagnosticFinding
}

export const FindingRow = ({ finding }: FindingRowProps) => {
  const dispatch = useAppDispatch()

  const handleClick = useCallback(() => {
    dispatch(setEditingEntity(finding.entityId))
    dispatch(
      setSettingsEditing({
        id: finding.entityId,
        type: finding.entityType,
      } as SettingsEditingType),
    )
  }, [dispatch, finding.entityId, finding.entityType])

  return (
    <button
      type="button"
      className="flex w-full cursor-pointer items-center gap-2 border-gray-100 border-x-0 border-t-0 border-b bg-transparent px-3 py-2 text-left text-[13px]"
      onClick={handleClick}
    >
      <SeverityBadge severity={finding.severity} />
      <span className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
        {finding.message}
      </span>
      <span className="shrink-0 text-gray-400 text-xs">
        {finding.entityType}
      </span>
    </button>
  )
}
